"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TonConnectRemoteBridge = void 0;
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const protocol_1 = require("@tonconnect/protocol");
const lodash_1 = require("lodash");
const TonConnect_1 = require("./TonConnect");
const models_1 = require("./models");
const storage_1 = require("../storage");
const telegram_storage_1 = require("../telegram-storage");
function isObject(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
class TonConnectRemoteBridgeService {
    // private origin: DeeplinkOrigin | null = null
    // private origin: DeeplinkOrigin | null = null
    constructor() {
        this.storeKey = 'ton-connect-http-bridge-lastEventId';
        this.bridgeUrl = 'https://sse-bridge.delab.team/bridge';
        this.defaultTtl = 300;
        this.eventSource = null;
        this.connections = [];
        this.activeRequests = {};
        this.returnStrategy = 'back';
        this._storage = sdk_1.default.initData.length !== 0 && !(sdk_1.default.platform === 'macos')
            ? new telegram_storage_1.TelegramStorage()
            : new storage_1.StorageWallet();
    }
    setReturnStrategy(returnStrategy) {
        if (returnStrategy) {
            this.returnStrategy = returnStrategy;
        }
    }
    async send(response, sessionCrypto, clientSessionId, ttl) {
        try {
            const url = `${this.bridgeUrl}/message?client_id=${sessionCrypto.sessionId}&to=${clientSessionId}&ttl=${ttl || this.defaultTtl}`;
            const encodedResponse = sessionCrypto.encrypt(JSON.stringify(response), (0, protocol_1.hexToByteArray)(clientSessionId));
            await fetch(url, {
                body: protocol_1.Base64.encode(encodedResponse),
                method: 'POST'
            });
        }
        catch (e) {
            console.log('send fail', e);
        }
    }
    redirectIfNeeded() {
        console.log('returnStrategy', this.returnStrategy);
        if (this.returnStrategy === 'back') {
            sdk_1.default.close();
        }
        else if (this.returnStrategy.startsWith('tg://') || this.returnStrategy.startsWith('https://t.me/')) {
            sdk_1.default.openTelegramLink(this.returnStrategy);
        }
        else if (this.returnStrategy !== 'none') {
            sdk_1.default.openLink(this.returnStrategy);
        }
        this.returnStrategy = 'back';
    }
    async handleConnectDeeplink(query, setShowConnectModal, setConnectModalProps, setConnectedApps, connectedApps) {
        try {
            const protocolVersion = Number(query.v);
            const clientSessionId = query.id;
            let request = JSON.parse(decodeURIComponent(query.r.replace(/--/g, '%')));
            if (!isObject(request)) {
                request = JSON.parse(request);
            }
            console.log('handleConnectDeeplink request', request);
            const sessionCrypto = new protocol_1.SessionCrypto();
            const response = await TonConnect_1.TonConnect.connect(protocolVersion, request, setShowConnectModal, setConnectModalProps, setConnectedApps, connectedApps, sessionCrypto, clientSessionId);
            console.log('handleConnectDeeplink response', response);
            await this.send(response, sessionCrypto, clientSessionId);
            const manifest = await TonConnect_1.TonConnect.getManifest(request);
            console.log('manifest after send responce', manifest);
            if (manifest.name === 'DeSim' || manifest.name === 'DeVPN') {
                if (sdk_1.default.platform !== 'tdesktop') {
                    sdk_1.default.close();
                }
            }
            this.redirectIfNeeded();
        }
        catch (err) {
            console.log('handleConnectDeeplink error', err);
        }
    }
    async open(connections, setShowSendModal, setTonconnectTransactionProps, setConnectedApps, connectedApps) {
        this.close();
        this.connections = connections.filter(item => item.type === models_1.TonConnectBridgeType.Remote);
        this.setShowSendModal = setShowSendModal;
        this.setTonconnectTransactionProps = setTonconnectTransactionProps;
        this.setConnectedApps = setConnectedApps;
        this.connectedApps = connectedApps;
        if (this.connections.length === 0) {
            return;
        }
        const walletSessionIds = this.connections
            .map(item => new protocol_1.SessionCrypto(item.sessionKeyPair).sessionId)
            .join(',');
        let url = `${this.bridgeUrl}/events?client_id=${walletSessionIds}`;
        const lastEventId = await this.getLastEventId();
        if (lastEventId) {
            url += `&last_event_id=${lastEventId}`;
        }
        console.log('sse connect', url);
        this.eventSource = new EventSource(url);
        this.eventSource.addEventListener('message', (0, lodash_1.debounce)(this.handleMessage.bind(this), 200));
        this.eventSource.addEventListener('open', () => {
            console.log('sse connect: opened');
        });
        this.eventSource.addEventListener('error', (event) => {
            console.log('sse connect: error', event);
        });
    }
    close() {
        if (this.eventSource) {
            // this.eventSource.removeAllEventListeners()
            this.eventSource.close();
            this.eventSource = null;
            console.log('sse close');
        }
    }
    async setLastEventId(lastEventId) {
        try {
            // await AsyncStorage.setItem(this.storeKey, lastEventId)
            this._storage.save(this.storeKey, lastEventId);
            // eslint-disable-next-line no-empty
        }
        catch { }
    }
    async getLastEventId() {
        try {
            // return await AsyncStorage.getItem(this.storeKey)
            // eslint-disable-next-line @typescript-eslint/return-await
            return await this._storage.get(this.storeKey);
        }
        catch {
            return null;
        }
    }
    async handleMessage(event) {
        try {
            if (event.lastEventId) {
                this.setLastEventId(event.lastEventId);
            }
            const { from, message } = JSON.parse(event.data);
            console.log('handleMessage', from);
            const connection = this.connections.find(item => item.clientSessionId === from);
            if (!connection) {
                console.log(`connection with clientId "${from}" not found!`);
                return;
            }
            const sessionCrypto = new protocol_1.SessionCrypto(connection.sessionKeyPair);
            const request = JSON.parse(sessionCrypto.decrypt(protocol_1.Base64.decode(message).toUint8Array(), (0, protocol_1.hexToByteArray)(from)));
            if (this.activeRequests[from]) {
                await this.send({
                    error: {
                        code: protocol_1.SEND_TRANSACTION_ERROR_CODES.USER_REJECTS_ERROR,
                        message: 'User has already opened the previous request'
                    },
                    id: request.id
                }, sessionCrypto, from);
                return;
            }
            this.activeRequests[from] = request;
            console.log('handleMessage request', request);
            if (!this.setShowSendModal || !this.setTonconnectTransactionProps || !this.setConnectedApps || !this.connectedApps) {
                console.log('unavailable setShowSendModal, setTonconnectTransactionProps');
                return;
            }
            const response = await TonConnect_1.TonConnect.handleRequestFromRemoteBridge(request, from, connection, this.setShowSendModal, this.setTonconnectTransactionProps, this.setConnectedApps, this.connectedApps);
            delete this.activeRequests[from];
            console.log('handleMessage response', response);
            await this.send(response, sessionCrypto, from);
            this.redirectIfNeeded();
        }
        catch (e) {
            console.log('handleMessage error');
            console.error(e);
        }
    }
}
exports.TonConnectRemoteBridge = new TonConnectRemoteBridgeService();
